// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC-0jpxCXD_I18LIowk4-g_8I91xYQ0ouw",
  authDomain: "devrev-8a83f.firebaseapp.com",
  projectId: "devrev-8a83f",
  storageBucket: "devrev-8a83f.appspot.com",
  messagingSenderId: "793461403132",
  appId: "1:793461403132:web:d9ef793ea7eebae74b9679"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;